export function idxTopicsFunc() {
  let openDt;
  openDt = $('dl.archive:first-child');
  openDt.find('dt').addClass('open');
}